const hasSharedArrayBuffer = (): boolean => {
	try {
		// biome-ignore lint/correctness/noConstantCondition: <explanation>
		if (new SharedArrayBuffer(0)) {
			return true;
		} else {
			return false;
		}
	} catch {
		return false;
	}
};

export default hasSharedArrayBuffer;
